@if (transactionsExportForm) {
  <div class="modal-content-container">
    <h1>{{ 'modal.transactionsXlsxExport.header' | translate }}</h1>

    @if(!preloader.generating) {
      <div class="section-label">
        {{ 'modal.transactionsXlsxExport.timeRange' | translate }}
      </div>

      <div class="time-inputs-container">
        <div class="time-input">
          <div class="form-label">
            {{ 'modal.transactionsXlsxExport.from' | translate }}
          </div>
          <div class="calendar-container">
              <input
                  class="calendar-input"
                  [owlDateTimeTrigger]="df"
                  [owlDateTime]="df"
                  [max]="today"
                  (dateTimeChange)="updateValidFromValue($event.value)"
                  readonly
              >
              <owl-date-time #df [pickerType]="'calendar'"></owl-date-time>
          </div>
        </div>

        <div class="time-input">
          <div class="form-label">
            {{ 'modal.transactionsXlsxExport.to' | translate }}
          </div>
          <div class="calendar-container">
              <input
                  class="calendar-input"
                  [owlDateTimeTrigger]="dt"
                  [owlDateTime]="dt"
                  [max]="today"
                  (dateTimeChange)="updateValidToValue($event.value)"
                  readonly
              >
              <owl-date-time #dt [pickerType]="'calendar'"></owl-date-time>
          </div>
        </div>
      </div>

      <div class="section-label">
        {{ 'modal.transactionsXlsxExport.transactionTypes' | translate }}
      </div>

      <div class="checkboxes-container">
        <div class="filtration-checkboxes-container">
          @for (checkbox of availableCheckboxes; track checkbox.label) {
            <div
              class="filtration-checkbox"
              [attr.data-cy]="'transaction-filtration-checkbox ' + checkbox.apiKey"
              >
              <label class="container pl-2" for="{{checkbox.label}}-export-xlsx">
                <input id="{{checkbox.label}}-export-xlsx" type="checkbox" name="{{checkbox.label}}-export-xlsx" [(ngModel)]="checkbox.value">
                <span class="checkmark"></span>
                {{ checkbox.label }}
              </label>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="export-in-progress">
        {{ 'modal.exportInProgress' | translate}}
      </div>
    }

    <div class="action-buttons-container">
      <libero-button
        label="{{ 'global.buttons.exportXlsx' | translate }}"
        btnClasses="btn--primary btn--heading btn--s-20"
        (click)="generateTransactionsExportLink()"
        [preloader]="preloader.generating"
        [buttonDisabled]="!selectedCheckboxes.length"
      ></libero-button>
    </div>
  </div>
}
